module.exports = __webpack_public_path__ + "img/film.34bcc2fc.svg";